import content from "./youtubeRankingContent.json";
import { normalizeLanguageCode } from "./supportedLanguages";

export type YouTubeRankingContent = {
  heading: string;
  description: string;
  supportedCountriesTitle: string;
  supportedCountriesIntro: string;
};

const CONTENT_BY_LANGUAGE: Record<string, YouTubeRankingContent> = content.locales;

export const YOUTUBE_RANKING_COUNTRY_CODES = content.countryCodes;

export function getYouTubeRankingContent(languageCode: string): YouTubeRankingContent {
  const normalizedLanguage = normalizeLanguageCode(languageCode);
  return CONTENT_BY_LANGUAGE[normalizedLanguage] ?? CONTENT_BY_LANGUAGE.en;
}
